<template>
  <div>
    <div class="pl-7 pt-4">
      <div class="font-primaria headline font-weight-bold fontColor1--text">PENDÊNCIAS</div>
      <div
        style="line-height: 8px"
        class="font-secundaria subtitle-2 fontColor1--text"
        v-if="!$vuetify.breakpoint.xs"
      >
        <span class="font-weight-bold">Home</span> > Pendência
      </div>
      <div class="font-secundaria subtitle-2 fontColor1--text" v-else>
        <span class="font-weight-bold">Home</span> > Pendência
      </div>
    </div>

    <CardPendencia
      @showPendencia="objeto => showPendencia(objeto)"
      :carregarTable="carregar"
      @carregouTable="value => carregar = value"
    />
    <recibo-cadu
      title="Análise Pendência"
      ref="modalPendencia"
      @aprovar="value => aprovacaoRecibo(value)"
      :v-model="show"
      :value="show"
      @input="input => show = input"
      :pendencia="true"
    />
    <SucessoModal :showSucess="showSucess" :genericMessage="messageSuccess" @close="sucesso" />
    <overlay-loading v-model="loadingOverlay"/>
    <error-modal v-model="showError" :errObj="errObj"/>
  </div>
</template>

<script>
import CardPendencia from './Shared/CardPendencia';
import Pendencia from '../../services/Pendencia/Pendencia';
import { EventBus } from '@/services/EventBus/EventBus';

export default {
  components: {
    CardPendencia
  },

  data () {
    return {
      show: false,
      tokenBearer: '',

      showSucess: false,
      type: 'add',
      messageSuccess: '',
      name: '',

      carregar: false,

      loadingOverlay: false,

      showError: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },

  created () {
    this.tokenBearer = localStorage.getItem('tokenBearer')
  },

  methods: {
    async showPendencia (objeto) {
      this.loadingOverlay = true
      await this.$refs.modalPendencia.startReciboPendencia(objeto.unimed.id)
      this.show = true
      this.loadingOverlay = false
    },

    sucesso () {
      this.carregar = true
      this.showSucess = false
    },

    async aprovacaoRecibo (objetoRecibo) {
      if (objetoRecibo.aprovado) {
        await this.aprovarRecibo(objetoRecibo.idUnimed)
      } else {
        await this.negarRecibo(objetoRecibo.idUnimed)
      }
    },

    async aprovarRecibo (unimedId) {
      this.loadingOverlay = true
      let pendencia = new Pendencia(
        this.tokenBearer,
        this.$appConfig.config.API,
        this.$idUnimed
      )

      try {
        await pendencia.postAprovarRecibo(unimedId)
        this.loadingOverlay = false
        this.show = false
        this.messageSuccess = 'Versão aprovada com sucesso!'
        this.showSucess = true
        EventBus.$emit('atualizarAlertas');
        window.location.reload();

      } catch (err) {
        this.loadingOverlay = false
        this.show = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        EventBus.$emit('atualizarAlertas');
      }
    },

    async negarRecibo (unimedId) {
      this.loadingOverlay = true
      let pendencia = new Pendencia(
        this.tokenBearer,
        this.$appConfig.config.API,
        this.$idUnimed
      )

      try {
        await pendencia.postNegarRecibo(unimedId)
        this.loadingOverlay = false
        this.show = false
        this.messageSuccess = 'Versão negada com sucesso!'
        this.showSucess = true
        EventBus.$emit('atualizarAlertas');
      } catch (err) {
        this.loadingOverlay = false
        this.show = false
        this.showError = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        EventBus.$emit('atualizarAlertas');
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
